import { render, staticRenderFns } from "./CultureHistoryIndex.vue?vue&type=template&id=27442b08&scoped=true&"
import script from "./CultureHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./CultureHistoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27442b08",
  null
  
)

export default component.exports